import { AssetType } from '../../../../../types/api';
import { LOAN } from './constants';
import type { PROJECT_TYPE } from './types';

/**
 * Derive the loan application's project_type from the asset types
 * selected on the Project Information section.
 *
 * - Only Solar selected             -> LOAN.PROJECT_TYPE.SOLAR
 * - Solar + any non-solar selected  -> LOAN.PROJECT_TYPE.SOLAR_PLUS
 * - Only EV Chargers selected       -> LOAN.PROJECT_TYPE.SOLAR
 * - EV Chargers + other non-solar   -> LOAN.PROJECT_TYPE.SOLAR_PLUS
 * - Other non-solar (no Solar)      -> LOAN.PROJECT_TYPE.FLEX
 * - Nothing selected                -> undefined
 */
const forAssetTypes = (
  selectedAssetTypes: ReadonlyArray<AssetType>
): PROJECT_TYPE | undefined => {
  if (selectedAssetTypes.length === 0) return undefined;
  const hasSolar = selectedAssetTypes.includes(AssetType.SOLAR);
  const hasNonSolar = selectedAssetTypes.some((t) => t !== AssetType.SOLAR);
  if (hasSolar && hasNonSolar) return LOAN.PROJECT_TYPE.SOLAR_PLUS;
  if (hasSolar) return LOAN.PROJECT_TYPE.SOLAR;

  const hasEvChargers = selectedAssetTypes.includes(AssetType.EV_CHARGERS);
  if (hasEvChargers && selectedAssetTypes.length === 1) {
    return LOAN.PROJECT_TYPE.SOLAR;
  }
  if (hasEvChargers) return LOAN.PROJECT_TYPE.SOLAR_PLUS;
  return LOAN.PROJECT_TYPE.FLEX;
};

export const ProjectTypes = {
  forAssetTypes,
};
